<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="ChevronLeftIcon" @click="close()" />
    </template>
    <template #title>Total to be billed</template>

    <Sheet.Body>
      <div class="overflow-hidden rounded-xl border border-[#EEEDEC] bg-white">
        <div
          class="flex bg-gray-200/15 px-[14px] py-[7px] font-secondary text-[12px] font-medium uppercase leading-[15px] text-[#656666]"
        >
          <div class="min-w-[200px] flex-1">Description</div>
          <div>Amount</div>
        </div>

        <div class="px-[14px] pt-2.5 pb-5">
          <div
            v-for="cost in breakdown"
            :key="cost.origin.id"
            class="mb-3 w-full font-secondary text-[13px] leading-[18px] text-gray-800 last:mb-0"
          >
            <div class="mb-1.5 flex items-center gap-x-2 font-medium">
              <Avatar
                v-if="cost.origin.flag?.url"
                :src="cost.origin.flag.url"
                :size="18"
              />
              <span>{{ cost.description }}</span>
            </div>
            <div class="flex flex-col pl-2.5">
              <div
                v-for="item in cost.breakdown"
                :key="item.id"
                class="flex items-center justify-between"
              >
                <div>{{ item.name }}</div>
                <div>{{ formatPrice({ amount: item.total.amount }) }}</div>
              </div>
              <div class="flex items-center justify-between">
                <div class="font-medium">Subtotal</div>
                <div class="font-medium text-[15px] leading-[17px]">
                  {{ formatPrice({ amount: cost.total.amount }) }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex h-10 items-center border-t border-[#EEEDEC] px-[14px]">
          <div
            class="flex-1 pr-[14px] text-right font-primary text-[12px] font-medium uppercase leading-[21px] tracking-[0.5px] text-[#656666]"
          >
            Total
          </div>
          <div
            class="flex h-full w-[116px] items-center justify-end border-l border-[#EEEDEC] font-secondary text-[18px] font-medium leading-[18px] text-gray-800"
          >
            {{ total }}
          </div>
        </div>
      </div>

      <p
        class="mt-3 text-right font-secondary text-[12px] leading-[16px] text-gray-500"
      >
        Bank sets final conversion rate. Bank fees may apply.
      </p>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Sheet, Avatar, useSheet } from '@dacr/library'
import { ChevronLeftIcon } from '@dacr/icons'
import { formatPrice } from '@/shared/utils/money'
import type { EstimateRegistrationCostQuery } from '@/shared/graphql/router/graphql'

const props = defineProps<{
  estimatedCost?: EstimateRegistrationCostQuery['estimateRegistrationCost']
}>()

const { close } = useSheet()

const breakdown = computed(() => props.estimatedCost?.breakdown ?? [])

const total = computed(() =>
  formatPrice({ amount: props.estimatedCost?.total.amount ?? 0 })
)
</script>
